﻿export default class SetPassword {
    constructor() {
        this.dom = {
            $: window.$,
            $pwrule: $('li[data-regex]')
        };
        this.init();
    }
    init() {
        this.onLoad();

        this.setPassword();
        this.loginBackClick();
        this.closePopup();
        if (this.dom.$pwrule.length > 0) {
            this.PWrules();
        }
    }
    onLoad() {

    }

    closePopup() {
        $('.content-popup-close').click(function (e) {
            $('.password-success-popup').hide();
            window.location.href = $(this).attr('href');
            return false;
        });
    }
    setPassword() {
        $('.set-password-submit').on('click', function (e) {
            $(".loading-screen").show();
            if ($('.password').val().length > 0) {
                event.preventDefault();
                var isValidationError = ($('.password').closest('.form-row').find('span.form-error').html().length > 0);
                if (isValidationError) {
                    $('.form .form-error-global').removeClass('hidden');
                    $(".loading-screen").hide();

                } else if ($(".form").valid()) {
                    $('.form .form-error-global').addClass('hidden');
                    var PasswordInput = {
                        "Email": GetParameterValues('ulemad'),
                        "Token": GetParameterValues('utokc'),
                        "Password": $('.password').val(),
                        "Otp": localStorage.getItem('otpProvided'),
                        "IsRequestFromVerifications": false
                    };
                    getAjaxData("/api/account/SetPassword", "POST", true, PasswordInput, function (data) {
                        $(".loading-screen").hide();
                        $('.reset-password-error-msg').hide();
                        if (data) {
                            if (data.isSuccess) {
                                $('.password-success-popup').show();
                                return false;
                            }
                            else {
                                $('.reset-password-error-msg').show();
                            }
                        }
                    });
                } else {
                    $(".loading-screen").hide();
                }
            } else {
                $(".loading-screen").hide();
            }
        });

        function GetParameterValues(name) {
            var finalResult = '';
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            if (results == null) { //stop returning NULL
                finalResult = '';
            } else {
                if (name == 'email') {
                    finalResult = results[0].replace('?email=', '');
                }
                else {
                    finalResult = results[1];
                }
            }
            return finalResult;
        }

    }

    loginBackClick() {
        $('.login-back').click(function (e) {
            event.preventDefault();
            $('.form .form-error-global').addClass('hidden');
            $('.login-div').attr("style", "display:none");
            $('.login-home-div').attr("style", "display:block");
        });
    }

    PWrules() {
        $('.password').on('keyup', () => {
            this.dom.$pwrule.each((id, liObj) => {
                var reg = new RegExp($(liObj).data('regex'));
                $(liObj).toggleClass('passed', reg.test($('.password').val())).toggleClass('failed', !reg.test($('.password').val()));
            });
        })
    }
}

document.addEventListener('DOMContentLoaded', () => new SetPassword());
